var MessageException = new (class MessageException extends AbstractModule {

  constructor() {
    super("MessageException");
    this._exceptions = {
      'email_form': this._emailForm
    }
  }

  // Returns true if at least one message was treated as an exception
  process(messages) {
    if (!Array.isArray(messages)) messages = [messages];
    let processed = false;
    messages.forEach(message => {
      processed = processed || this._process(message);
    });
    return processed;
  }

  _process(message) {
    let exceptionHandled = true;
    let exceptionMethod = this._exceptions[message.exception_name];
    if (exceptionMethod) {
      exceptionMethod.call(this, message);
      message.conversation.removeMessage(message);
      return true;
    }
    else {
      return false;
    }
  }

  _emailForm(message) {
    const conversation         = message.conversation;
    const messageExceptionData = JSON.parse(message.exception_data);
    const botTreeEntryId       = messageExceptionData.bot_tree_entry_id;
    const texts                = messageExceptionData.texts;
    const guestEmail           = messageExceptionData.email;
    const originalMessageIndex = conversation.getMessageIndex(message);

    clearTimeout(conversation.waiting_for_answer_timeout);
    let ticketing_system_html = '';

    if (this.app._ticketing_system_names != [] && this.app._ticketing_system_names != null) {
      let ticketing_system_options = '';

      for (var i = 0; i < this.app._ticketing_system_names.length; i++)
        ticketing_system_options += `<option value="${this.app._ticketing_system_names[i].id}">${this.app._ticketing_system_names[i].name}</option>`

      if (ticketing_system_options != '')
        ticketing_system_html = '<div><select id="slaask-offline-ticketing_system-input" name="ticketing" class="chat-input slaask-input-offline">' + ticketing_system_options + '</select></div>'
    }

    let text = `
      <form class="slaask-offline-form">
        <input id="slaask-email-input" name="email" class="chat-input slaask-input-offline" value="${guestEmail || this.app._getEmail() || ''}" placeholder="${texts.email_form_email_placeholder}" type="email" required="required" />
        <div id="slaask-offline-form-error" class="slaask-offline-form-error"></div>
        ${ticketing_system_html}
        <textarea id="slaask-offline-message-input" name="text" class="chat-input slaask-input-offline" placeholder="${texts.email_form_message_placeholder}" type="text" required="required"></textarea>
        <input class="slaask-btn" type="submit" value="${texts.email_form_submit_button}">
      </form>`;

    let emailFormMessage = new Message(MS.bot, text);
    emailFormMessage.type = "notification";
    emailFormMessage.focus = "#slaask-email-input";
    emailFormMessage.mandatory_buttons = true;

    emailFormMessage.addInteraction({
      selector: '.slaask-offline-form',
      event: 'submit',
      removeButtons: true,
      handler: e => {
        e.preventDefault();
        let email = e.currentTarget.email.value;
        let subject = e.currentTarget.subject ? e.currentTarget.subject.value : undefined;
        let ticketing = e.currentTarget.ticketing ? e.currentTarget.ticketing.value : null;
        let text = e.currentTarget.text.value;

        if (email.length > 0 && text.length > 0) {
          if (/^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
            Ajax.call('/api/send_email', {
              'key': this.app._api_key,
              'email': email,
              'message': text,
              'ticketing_system_key': ticketing,
              'object': subject,
              'message_id': message.id,
              'bot_tree_entry_id': botTreeEntryId
            });

            emailFormMessage.conversation.removeMessage(emailFormMessage);
          }
          else {
            emailFormMessage.querySelector('#slaask-offline-form-error').innerHTML = email + ' ' + texts.email_not_valid;
            emailFormMessage.querySelector('#slaask-email-input').focus();
          }
        }
        else {
          Utils.warn("Email or text is empty");
          return false
        };
      }
    });

    conversation.addMessage(emailFormMessage);
    conversation.reorderMessage(emailFormMessage, originalMessageIndex);
  }
});
